import { ScheduleProps } from '../../components/meals/AddMeals';
import { LocationState } from '../user/types';

export const GET_ORDERS = 'GET_ORDERS';
export const SET_COOKS = 'SET_COOKS';
export const GET_COOKS = 'GET_COOKS';
export const SET_ORDERS = 'SET_ORDERS';
export const ACCEPT_ORDER = 'ACCEPT_ORDER';
export const RATE_GUEST = 'RATE_GUEST';
export const GET_RATINGS = 'GET_RATINGS';
export const SET_RATINGS = 'SET_RATINGS';

export interface FirestoreSnapshot {
  id: string;
  data: Function;
}

export interface DateObjects {
  seconds?: any;
  nanoseconds?: string;
}

export interface UserAddres {
  city: string;
  note: string;
  street: string;
}

export interface UserDetails {
  id: string;
  firstName: string;
  address: UserAddres;
  image: string;
  phone: string;
  type: string;
  location: LocationState;
  description: string;
}

export interface Orders {
  id: string;
  mealid: string;
  name: string;
  portions: string;
  title: string;
  rating: string;
  description: string;
  mealprice: string;
  ordertotal: string;
  consumption: string;
  status: string;
  refusedmessage: string;
  image: string;
  timeadded: DateObjects;
  userdetails: UserDetails;
  cookDetails?: UserDetails;
  consumptiondate: DateObjects;
  schedule: ScheduleProps[];
  cook: string;
  guest: string;
}

export interface Ratings {
  rate: number;
  message: string;
  meal: string;
  order: string;
  ratedby: string;
  user: string;
  timeadded: Date;
  userdetails?: UserDetails;
}

export interface OrderProps {
  orders: Array<Orders>;
  userinfo: UserDetails;
  ratings: Ratings[];
}

export interface GetCooksDetailsAction extends OrderProps {
  type: typeof GET_COOKS;
  userid: string;
}

export interface SetCooksActionType extends OrderProps {
  type: typeof SET_COOKS;
  userinfo: UserDetails;
}

export interface GetOrderAction extends OrderProps {
  type: typeof GET_ORDERS;
}

export interface SetOrderActionType extends OrderProps {
  type: typeof SET_ORDERS;
  orders: Array<Orders>;
}

export interface AcceptOrderAction extends OrderProps {
  type: typeof ACCEPT_ORDER;
  orderid: string;
  status: string;
  refusedmessage: string;
  guestid: string;
}

export interface RateGuestAction {
  type: typeof RATE_GUEST;
  ratings: Ratings;
}

export interface GetRatings {
  type: typeof GET_RATINGS;
}

export interface SetRatingsAction extends OrderProps {
  type: typeof SET_RATINGS;
  ratings: Ratings[];
}

export type OrderActionTypes =
  | GetOrderAction
  | SetOrderActionType
  | SetCooksActionType
  | GetCooksDetailsAction
  | SetRatingsAction;
